import { createAction } from '@reduxjs/toolkit';

import { SPEED_TEST_DATA_LOAD_STARTED } from '../constants/action-types';

export const loadInitialDataStart = createAction(SPEED_TEST_DATA_LOAD_STARTED);
